import React from 'react';

const CoursNage = () => {
    return (
        <div>
            <h1>Cursos de natació</h1>
        </div>
    );
};

export default CoursNage;